import Message from './Message'

export default Message



// WEBPACK FOOTER //
// ./src/components/message/index.js